import { c as _c } from "react/compiler-runtime";
import { AeroHero3 } from "@/shared/ui/aero-hero-3";
import { SiteNavbar } from "@/shared/ui/site-navbar";
import { SiteFooter } from "@/shared/ui/site-footer";
import { HomeHelpSection } from "@/features/home/presentation/components/home-help-section";
import { HomeHowWeWorkSection } from "@/features/home/presentation/components/home-how-we-work-section";
import { HomeServiceSection } from "@/features/home/presentation/components/home-service-section";
import { HomeTrustStrip } from "@/features/home/presentation/components/home-trust-strip";
import { HomeComplexityClaritySection } from "@/features/home/presentation/components/home-complexity-clarity-section";
import { HomeEmotionalConnectionSection } from "@/features/home/presentation/components/home-emotional-connection-section";
import { HomeWellnessFeaturesSection } from "@/features/home/presentation/components/home-wellness-features-section";
import { HomeBlogPreviewSection } from "@/features/home/presentation/components/home-blog-preview-section";
import { HomeFeaturedAssessmentsSection } from "@/features/home/presentation/components/home-featured-assessments-section";
import { HomeTestimonialsSection } from "@/features/home/presentation/components/home-testimonials-section";
import { HomeFaqSection } from "@/features/home/presentation/components/home-faq-section";
import { HomeCtaSection } from "@/features/home/presentation/components/home-cta-section";
import type { HomePageContent } from "@/features/home/types/home-page-content";
import type { AppLocale } from "@/core/i18n/config";
import type { BlogPost } from "@/features/blogs/types/blog";
import type { Assessment } from "@/features/assessment/types";
interface HomePageProps {
  content: HomePageContent;
  locale: AppLocale;
  blogs?: BlogPost[];
  featuredAssessments?: Assessment[];
}
export function HomePage(t0) {
  const $ = _c(55);
  const {
    content,
    locale,
    blogs,
    featuredAssessments: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const featuredAssessments = t2;
  const {
    complexityClaritySection,
    ctaSection,
    emotionalConnectionSection,
    faqSection,
    footer,
    helpSection,
    hero,
    howWeWorkSection,
    homeServiceSection,
    navigation,
    testimonialsSection,
    trustSection,
    wellnessFeaturesSection
  } = content;
  let t3;
  if ($[2] !== navigation) {
    t3 = <SiteNavbar content={navigation} />;
    $[2] = navigation;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== hero.backgroundImageUrl || $[5] !== hero.ctaHref || $[6] !== hero.ctaLabel || $[7] !== hero.description || $[8] !== hero.eyebrow || $[9] !== hero.title) {
    t4 = <div className="sticky top-0 h-[100svh] overflow-hidden"><AeroHero3 backgroundImageUrl={hero.backgroundImageUrl} className="h-full min-h-full" ctaHref={hero.ctaHref} ctaLabel={hero.ctaLabel} description={hero.description} id="home" eyebrow={hero.eyebrow} title={hero.title} /></div>;
    $[4] = hero.backgroundImageUrl;
    $[5] = hero.ctaHref;
    $[6] = hero.ctaLabel;
    $[7] = hero.description;
    $[8] = hero.eyebrow;
    $[9] = hero.title;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== trustSection) {
    t5 = <HomeTrustStrip content={trustSection} />;
    $[11] = trustSection;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== homeServiceSection) {
    t6 = <HomeServiceSection content={homeServiceSection} />;
    $[13] = homeServiceSection;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== complexityClaritySection) {
    t7 = <HomeComplexityClaritySection content={complexityClaritySection} />;
    $[15] = complexityClaritySection;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== howWeWorkSection) {
    t8 = <HomeHowWeWorkSection content={howWeWorkSection} />;
    $[17] = howWeWorkSection;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== helpSection) {
    t9 = <HomeHelpSection content={helpSection} />;
    $[19] = helpSection;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== wellnessFeaturesSection) {
    t10 = <HomeWellnessFeaturesSection content={wellnessFeaturesSection} />;
    $[21] = wellnessFeaturesSection;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== emotionalConnectionSection) {
    t11 = <HomeEmotionalConnectionSection content={emotionalConnectionSection} />;
    $[23] = emotionalConnectionSection;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== featuredAssessments || $[26] !== locale) {
    t12 = <HomeFeaturedAssessmentsSection locale={locale} assessments={featuredAssessments} />;
    $[25] = featuredAssessments;
    $[26] = locale;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== testimonialsSection) {
    t13 = <HomeTestimonialsSection content={testimonialsSection} />;
    $[28] = testimonialsSection;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== blogs || $[31] !== locale) {
    t14 = <HomeBlogPreviewSection locale={locale} blogs={blogs} />;
    $[30] = blogs;
    $[31] = locale;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== faqSection) {
    t15 = <HomeFaqSection content={faqSection} />;
    $[33] = faqSection;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== ctaSection) {
    t16 = <HomeCtaSection content={ctaSection} />;
    $[35] = ctaSection;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== footer) {
    t17 = <SiteFooter content={footer} />;
    $[37] = footer;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t10 || $[40] !== t11 || $[41] !== t12 || $[42] !== t13 || $[43] !== t14 || $[44] !== t15 || $[45] !== t16 || $[46] !== t17 || $[47] !== t3 || $[48] !== t4 || $[49] !== t5 || $[50] !== t6 || $[51] !== t7 || $[52] !== t8 || $[53] !== t9) {
    t18 = <main className="relative flex flex-1 flex-col bg-[#0b1416]">{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}</main>;
    $[39] = t10;
    $[40] = t11;
    $[41] = t12;
    $[42] = t13;
    $[43] = t14;
    $[44] = t15;
    $[45] = t16;
    $[46] = t17;
    $[47] = t3;
    $[48] = t4;
    $[49] = t5;
    $[50] = t6;
    $[51] = t7;
    $[52] = t8;
    $[53] = t9;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  return t18;
}